export default "__VITE_ASSET__B13s5ky___"